module.exports = __webpack_public_path__ + "img/common-arrow-next.6c9a4fb2.svg";